<template>
    <div class="simple-form flex col-2">
        <div class="form-group">
            <div class="form-label">
                <label>名称:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.name }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>代码:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.code }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>是否三证合一:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.integratedFlag ? '是' : '否' }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>执照注册号:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.registNo }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>统一社会信用代码:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.socialCreditCode }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>企业类型:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.orgForm }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>组织机构代码:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.orgCode }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>法人代表:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.legalPerson }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>注册资金:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.registCapital }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>成立日期:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.foundDate }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>营业开始日期:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.bizTermStartDate }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>营业截止日期:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.bizTermEndDate }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>税务登记号:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.taxRegistNo }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>纳税类型编码:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.taxPayTypeCode }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>纳税类型:</label>
            </div>
            <div class="form-value">
                <span>{{ taxPayTypeMap[realCom.taxPayType] }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label></label>
            </div>
            <div class="form-value">
                <span>&nbsp;</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>员工人数:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.staffCount }}</span>
            </div>
        </div>
        <div class="form-group center">
            <div class="form-label">
                <label>是否抵扣税</label>
            </div>
            <div class="form-value">
                <el-switch v-model="realCom.taxFree" active-color="#13ce66" :disabled="true"></el-switch>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>联系人姓名:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.contactName }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>联系电话:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.contactTel }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>联系邮箱:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.contactEmail }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>创建时间:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.createTime }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>创建人:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.creatorName }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>经营范围:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.bizScope }}</span>
            </div>
        </div>
        <div class="form-group">
            <div class="form-label">
                <label>公司简介:</label>
            </div>
            <div class="form-value">
                <span>{{ realCom.briefIntro }}</span>
            </div>
        </div>
    </div>
</template>

<script>
    import { Utils } from '../../app.base'
    import { Vue, MsgBox, Routes } from '../../app.vues'

    import merchtComnApi from '../../api/merchtComn'

    export default {
        name: 'swb-real-com-detail',
        desc: '实体公司详情',
        props: ['id'],
        data: function () {
            return {
                realCom: {},
                taxPayTypeMap: getEnumMap("taxPayType", "value2text")
            }
        },
        created: function () {
            this.getRealCom();
        },
        methods: {
            getRealCom(){
                let self = this;
                let postData = {};
                postData.id = this.id;
                let theLoading = MsgBox.loading();
                merchtComnApi.getRealCom(postData, function (result) {
                    theLoading.close();
                    if(result.type == 'info') {
                        self.realCom = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            }
        }
    }
</script>
<style>
    .form-row.col .form-label {
        width: 126px;
    }
</style>



// WEBPACK FOOTER //
// src/compo/comn/RealComDetail.vue